export const creatorType = {
  school: 'SCHOOL',
  team: 'TEAM',
  teacher: 'TEACHER',
} as const;
